import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import Avatar from '@classify/react-core-components/Avatar';
const PREFIX = 'PeopleItem';
const classes = {
  root: `${PREFIX}-root`,
  avatarContainer: `${PREFIX}-avatarContainer`,
  userName: `${PREFIX}-userName`,
  subHeading: `${PREFIX}-subHeading`,
  linked: `${PREFIX}-linked`
};
const Root = styled('span')(/* istanbul ignore next */({
  theme: {
    spacing,
    typography,
    palette
  }
}) => ({
  display: 'flex',
  color: palette.text.onMain,
  textDecoration: 'none',
  [`& .${classes.avatarContainer}`]: {
    marginRight: spacing(2)
  },
  [`& .${classes.userName}`]: {
    fontWeight: typography.fontWeightBold,
    lineHeight: '1.2rem'
  },
  [`& .${classes.subHeading}`]: {
    color: palette.text.onMain,
    '&::first-letter': {
      textTransform: 'capitalize'
    }
  },
  [`&.${classes.linked}`]: {
    [`& .${classes.userName}`]: {
      textDecoration: 'underline'
    }
  }
}));

/**
 * @deprecated
 * ### Description
 * `PeopleItem` has been deprecated and replaced by Classify `UserItemDesignation`.
 *
 * ### Example
 * ```
 * import UserItemDesignation from '@classify/react-core-components/UserItemDesignation';
 * ```
 */
export default function PeopleItem(t0) {
  const $ = _c(18);
  const {
    userId,
    userName,
    subHeading,
    avatarUrl: t1,
    linkComponent: t2,
    linkProps: t3
  } = t0;
  const avatarUrl = t1 === undefined ? null : t1;
  const LinkComponent = t2 === undefined ? "a" : t2;
  const linkProps = t3 === undefined ? null : t3;
  let t4;
  if ($[0] !== avatarUrl || $[1] !== userId || $[2] !== userName) {
    t4 = <span className={classes.avatarContainer}><Avatar userName={userName} userId={userId} src={avatarUrl} /></span>;
    $[0] = avatarUrl;
    $[1] = userId;
    $[2] = userName;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== userName) {
    t5 = <Typography component="p" className={classes.userName} variant="body">{userName}</Typography>;
    $[4] = userName;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== subHeading) {
    t6 = <Typography component="p" variant="bodySmall" className={classes.subHeading}>{subHeading}</Typography>;
    $[6] = subHeading;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <span>{t5}{t6}</span>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const content = t8;
  let t9;
  if ($[14] !== LinkComponent || $[15] !== content || $[16] !== linkProps) {
    t9 = linkProps ? <Root as={LinkComponent} {...linkProps} className={`${classes.root} ${classes.linked}`}>{content}</Root> : <Root {...linkProps} className={classes.root}>{content}</Root>;
    $[14] = LinkComponent;
    $[15] = content;
    $[16] = linkProps;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}